import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { basicStoresListQueries } from '@/services/basicStores/basicStores.queries';
import { useSearch } from '@tanstack/react-router';

export const useBasicStoresList = () => {
  const search = useSearch({ from: '/(app)/store-information/basic-stores/' });
  const { createdDate, page, fetch } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { data, isFetched, isLoading } = useQuery({
    ...basicStoresListQueries.list({
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
      row: page ?? 0,
      fetch: fetch ?? 10,
      location: '',
      search: search.q ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });
  return {
    basicStores: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
